export default __webpack_public_path__ + "static/media/spa-image-08.14f31d40.jpg";